import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from "../../flux/Flux";
import Constants from "../../flux/Constants";

export default function withActorInterviews(WrappedComponent) {
	class WithActorInterviews extends React.PureComponent {

		constructor(props) {
			super(props);

			this.state = {
				interviews: Flux.Actor.getActorInterviews(this.props.actorId, this.props.imageSize, true, this.props.durationFormat),
			};

			this.onInterviewsChange = this.onInterviewsChange.bind(this);
		}

		componentDidMount() {
			Flux.Actor.addInterviewsChangeListener(this.onInterviewsChange);

			if (this.state.interviews.length === 0) {
				Flux.Actor.loadActorInterviews(this.props.actorId, this.props.imageSize, true, this.props.durationFormat);
			}
		}

		componentWillUnmount() {
			Flux.Actor.removeInterviewsChangeListener(this.onInterviewsChange);
		}

		onInterviewsChange(actorId) {
			if (actorId === this.props.actorId) {
				this.setState((state, props) => ({
					interviews: Flux.Actor.getActorInterviews(props.actorId, props.imageSize, true, props.durationFormat),
				}));
			}
		}

		render() {
			return <WrappedComponent {...this.props} interviews={this.state.interviews} />;
		}
	}

	WithActorInterviews.propTypes = {
		actorId:        PropTypes.number.isRequired,
		imageSize:      PropTypes.string,
		durationFormat: PropTypes.string,
	};

	WithActorInterviews.defaultProps = {
		imageSize:      Constants.Interviews.IMAGE_SIZE_240,
		durationFormat: Constants.Interviews.DURATION_MIN,
	};

	WithActorInterviews.displayName = `WithActorInterviews(${getDisplayName(WrappedComponent)})`;

	return WithActorInterviews;
}

function getDisplayName(WrappedComponent) {
	return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
